export default __webpack_public_path__ + "ef44ef0aa1b4c02ea29018bf86ce82b9.png";